import { Component, OnInit, inject } from '@angular/core';
import { PageComponent } from 'src/app/components/pages/page.component';
import { APPLICATION_ROUTES } from 'src/app/constants/application-routes';
import { AdobePageName } from 'src/app/services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from 'src/app/services/adobe-launch/adobe-launch.service';
import { TitleService } from 'src/app/services/title/title.service';

import { ContentUtil } from '../../../../../utils/content/content.util';
import { InterstitialPageContentComponent } from 'src/app/components/interstitial-page-content/interstitial-page-content.component';

@Component({
    selector: 'zci-remove-user',
    templateUrl: './remove-users-page.component.html',
    styleUrls: ['./remove-users-page.component.scss'],
    imports: [
        InterstitialPageContentComponent,
    ],
})
export class RemoveUsersPageComponent extends PageComponent implements OnInit {
    private readonly adobeLaunchService = inject(AdobeLaunchService);
    private titleService = inject(TitleService);

    appRoutes = APPLICATION_ROUTES;

    content = ContentUtil.content;

    ngOnInit(): void {
        this.titleService.setTitle(this.content.accountInterstitialPages.removeUser.pageTitle);
        this.adobeLaunchService.pageLoad(AdobePageName.OWN_ACCOUNTS_REMOVE_USERS_PAGE);
    }
}
